import React from "react";
import { Box, Chip, Paper, Typography } from "@mui/material";
import { PageContainer } from "../../components/PageContainer";
import { SelectBandList } from "./SelectBandList";
import { useSelectBandReport } from "./useSelectBandReport";
import { DateRangeNav } from "./DateRangeNav";
import { useDateRange } from "./useDateRange";

const SelectBandPage = () => {
  const dateRange = useDateRange();
  const { startDate, endDate } = dateRange;
  const { items, labelHeader, loading, error } = useSelectBandReport({ startDate, endDate });

  return (
    <PageContainer title="Band Selection Events">
      <Paper sx={{ p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            <Chip label="eventName = select_band" variant="outlined" />
            <Chip label="bookingId = (not set)" variant="outlined" />
          </Box>
          <DateRangeNav dateRange={dateRange} />
        </Box>
        {loading ? (
          <Typography variant="body2" color="text.secondary">
            Loading report...
          </Typography>
        ) : error ? (
          <Typography variant="body2" color="error">
            Failed to load report.
          </Typography>
        ) : (
          <SelectBandList
            items={items}
            showSecondary
            labelHeader={labelHeader}
          />
        )}
      </Paper>
    </PageContainer>
  );
};

export default SelectBandPage;
